import React, { useState } from 'react';
import { authService } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';

export default function AccountManager() {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState({ text: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMsg({ text: 'Mật khẩu xác nhận không khớp.', type: 'error' });
      return;
    }
    if (newPassword.length < 6) {
      setMsg({ text: 'Mật khẩu mới phải có ít nhất 6 ký tự.', type: 'error' });
      return;
    }

    setSaving(true);
    setMsg({ text: '', type: '' });
    try {
      await authService.changePassword(currentPassword, newPassword);
      setMsg({ text: 'Đổi mật khẩu thành công!', type: 'success' });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setMsg({ text: err.message || 'Lỗi đổi mật khẩu.', type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="admin-panel">
      <div className="panel-head">
        <div>
          <h2>Tài khoản</h2>
          <p className="panel-head__sub">Thông tin user đang đăng nhập và đổi mật khẩu.</p>
        </div>
      </div>

      <div className="account-box">
        <div className="account-row"><strong>Email:</strong> <span>{user?.email || '—'}</span></div>
        <div className="account-row"><strong>Họ tên:</strong> <span>{user?.full_name || '—'}</span></div>
        <div className="account-row"><strong>Vai trò:</strong> <span>{user?.role || 'admin'}</span></div>
        <div className="account-row"><strong>User ID:</strong> <code>{user?.id || '—'}</code></div>
      </div>

      <div className="account-box" style={{ marginTop: '24px' }}>
        <h3 style={{ margin: '0 0 16px' }}>Đổi mật khẩu</h3>
        <form onSubmit={handleSubmit} className="admin-form">
          <label className="field">
            <span className="field__label">Mật khẩu hiện tại <em>*</em></span>
            <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
          </label>
          <label className="field">
            <span className="field__label">Mật khẩu mới <small>(tối thiểu 6 ký tự)</small> <em>*</em></span>
            <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
          </label>
          <label className="field">
            <span className="field__label">Xác nhận mật khẩu mới <em>*</em></span>
            <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
          </label>

          {msg.text && (
            msg.type === 'error'
              ? <p className="form-alert" role="alert">{msg.text}</p>
              : <p style={{ color: 'var(--c-green-700)', fontWeight: 600, margin: '12px 0' }}>✓ {msg.text}</p>
          )}

          <div className="form-actions">
            <button type="submit" className="btn btn--primary" disabled={saving}>
              {saving ? 'Đang cập nhật…' : 'Cập nhật mật khẩu'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
